import { createSelector } from 'reselect';
import getModuleState from './moduleStateSelector';

const getTabSelected = createSelector(
  getModuleState,
  (state) => state.get('tabSelected')
);

export const getIsSpecificTabSelected = (tab) => createSelector(
  getTabSelected,
  (selectedTab) => tab === selectedTab
);

export default getTabSelected;
